import React, { useState } from 'react';
import PropTypes from 'prop-types';
import StarRating from './StarRating/StarRating';
import ModalForm from './ModalForm/ModalForm';
import Button from '../Button/Button';
import { leaveFeedback } from '../../service/Feedback.service';
import { useNavigate } from 'react-router-dom';
import { handleError } from '../../service/base.service';
import { redirectUnauthorized } from '../../utils/errors';

const FeedbackPanel = ({
  disabled = false,
  requestTryNumber,
  contentRequestId,
  feedback = {},
  onChange
}) => {
  const navigate = useNavigate();
  const { score, text } = feedback;
  const [showModalForm, setShowModalForm] = useState(false);

  const saveFeedback = async (feedback) => {
    try {
      onChange?.(feedback);
      await leaveFeedback({ requestTryNumber, contentRequestId, ...feedback });
    } catch (e) {
      handleError(e, {
        UnauthorizedError: () => redirectUnauthorized(navigate),
        default: () => console.error(e)
      });
    }
  };

  const updateRating = async ({ score }) => {
    await saveFeedback({ ...feedback, score });
  };

  const updateText = async ({ text }) => {
    await saveFeedback({ ...feedback, text });
    setShowModalForm(false);
  };

  return (
    <>
      <span className="mr-4 font-sans text-sm">How happy are you with this result?</span>

      <StarRating disabled={disabled} score={score} onClick={updateRating} className="mr-4" />

      <Button
        disabled={disabled}
        onClick={() => setShowModalForm(true)}
        label="Leave Feedback"
        name="feedback"
        dataTest="leave-feedback-button"
        type="button"
        className="rounded-sm border border-black shadow-sm bg-white text-sm py-1 px-4 mr-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-default disabled:opacity-50"
      />

      <ModalForm
        text={text}
        isOpen={showModalForm}
        onClose={() => setShowModalForm(false)}
        onSubmit={updateText}
      />
    </>
  );
};

FeedbackPanel.propTypes = {
  disabled: PropTypes.bool,
  feedback: PropTypes.shape({
    score: PropTypes.number,
    text: PropTypes.string
  }),
  requestTryNumber: PropTypes.number.isRequired,
  contentRequestId: PropTypes.string.isRequired,
  onChange: PropTypes.func
};

export default FeedbackPanel;
